/**
 * Frontend configuration.
 *
 * Every environment-dependent value is read here once, so no component ever
 * references `import.meta.env` directly and nothing is hardcoded per stage.
 */
export interface WebConfig {
  apiBaseUrl: string;
  useMocks: boolean;
  stage: 'dev' | 'stg' | 'prod';
  cognito: {
    userPoolId?: string;
    clientId?: string;
    region: string;
  };
}

function readBoolean(value: string | undefined, fallback: boolean): boolean {
  if (value === undefined || value === '') return fallback;
  return value === 'true' || value === '1';
}

export const config: WebConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  // Mocks default on in dev so the UI runs before the API is deployed, and
  // default off everywhere else so a missing flag can never ship fake data.
  useMocks: readBoolean(import.meta.env.VITE_USE_MOCKS, import.meta.env.DEV),
  stage: import.meta.env.VITE_STAGE ?? 'dev',
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    region: import.meta.env.VITE_COGNITO_REGION ?? 'us-east-1',
  },
};
